export enum UploadErrorEnum {
  MissingFileName = 'missingFileName',
  FileAlreadyExists = 'fileAlreadyExists', // TODO: to remove ? Not fired in the backend anymore
  DirectoryNotFound = 'directoryNotFound',
  NoContent = 'noContent',
  ChunkIndexNotFound = 'chunkIndexNotFound',
  FileNotFound = 'fileNotFound',
}
